import TransactionsTable from '../../../components/tables/transactionsTable/transactionsTable';
import { ClientGroup } from '../../../interfaces';

const CorporationTransfers = ({ clientGroup }: { clientGroup: ClientGroup }) => (
  <TransactionsTable filter={{ clientGroupId: clientGroup.id }} />
);

export default CorporationTransfers;
